<template>
  <div v-if="profile" class="employee-details">

    <div v-if="!profile.fullName" class="text-center">
      <LoadingIcon/>
    </div>

    <div v-else class="row">
      <div class="col-12">

        <div class="row">
          <div class="col-12">
            <div class="row">
              <div class="col-12">
                <ul>
                  <li><span class="key">Your Name:</span><span class="value">{{ profile.fullName }}</span></li>
                  <li><span class="key">Mobile Phone:</span><span class="value">{{ profile.mobile }}</span></li>
                  <li><span class="key">Home Address:</span><span class="value">{{ profile.homeAddress }}</span></li>
                  <li><span class="key">Postcode: </span><span class="value">{{ profile.postcode }}</span></li>
                </ul>
                <ul>
                  <li><span class="key">Private:</span><span class="value">{{
                      Number(profile.privateAnnualMileage)
                    }}</span></li>
                  <li><span class="key">Business:</span><span class="value">{{
                      Number(profile.businessAnnualMileage)
                    }}</span></li>
                  <li><span class="key">Tax Band:</span><span class="value">{{
                      profile.incomeTaxBand.ratePercent
                    }}%</span></li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <div class="agree mb-0">
              <input type="checkbox" name="disclaimer_1" id="disclaimer_1"
                     v-model="employeeDetails" class="disclaimer_1">
              <label for="disclaimer_1">{{ declaration }}</label>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
  <div v-else class="my-5 text-center">
    <LoadingIcon/>
  </div>

</template>

<script>
import LoadingIcon from "@/components/loading-icon.vue";

export default {
  components: {LoadingIcon},
  props: ['profile', 'session', 'declaration'],
  data: () => {
    return {
      employeeDetails: null,
    }
  },
  watch: {
    employeeDetails(value) {
      this.$parent.confirmations.employeeDetails = value;
    },
  },
  computed: {

    privateCarMileageReimbursementRate() {
      if (!this.session?.driverProfile?.PCH) {
        return '';
      }
      return this.session.driverProfile.PCH.driverGradeDefinition.businessFuelPolicyName;
    },
    privateCarMileageReimbursementRateUpTo() {
      if (!this.session?.driverProfile?.PCH) {
        return '';
      }
      let fuelRate = '';
      this.session.driverProfile.PCH.driverGradeDefinition.businessFuelRates[0].items.forEach((item) => {
        if (Number(item.upToDistance) <= 10000) {
          fuelRate = (item.fuelRate * 100) + ' ppm';
        }
      });

      return fuelRate;
    },
    privateCarMileageReimbursementRateOver() {
      let maxDistance = 0;
      let maxFuelRate = '';

      if (!this.session?.driverProfile?.PCH) {
        return '';
      }

      this.session.driverProfile.PCH.driverGradeDefinition.businessFuelRates[0].items.forEach((item) => {
        if (Number(item.upToDistance) > 10000 && Number(item.upToDistance) > maxDistance) {
          maxDistance = item.upToDistance;
          maxFuelRate = (item.fuelRate * 100) + ' ppm';
        }
      });
      return maxFuelRate;
    }
  }
};
</script>
